const handleImageErrorWithPasomaruFallback = async (e, sku) => {
  const img = e.target;

  if (!img.dataset.retry) {
    try {
      await fetch(`/inventory/download_pasomaru_image/${sku}/`);
      img.src = `/media/product_images/${sku}.jpg`;
      img.dataset.retry = "true";
    } catch (error) {
      console.error("パソマル画像ダウンロード失敗:", error);
      img.src = "/media/system_images/noimage.jpg";
    }
  } else {
    img.src = "/media/system_images/noimage.jpg";
  }
};

export default handleImageErrorWithPasomaruFallback;
